export const Switch = ({
	checked, // boolean
	disabled, // boolean
	onChange,
}) => {
	return (
		<label
			className={`relative inline-block w-10 min-w-10 h-6 ${disabled ? "opacity-50" : ""}`}
		>
			<input
				type="checkbox"
				className="peer opacity-0 w-0 h-0"
				checked={checked}
				onChange={disabled ? null : onChange}
			/>
			<span className="absolute w-full h-full rounded-xl bg-[#DFDFDF] before:conent-[''] before:absolute before:top-[3px] before:left-[3px] before:w-[18px] before:h-[18px] before:rounded-xl before:bg-white peer-checked:bg-color_background_primary_3 peer-checked:before:translate-x-[16px] transition-all"></span>
		</label>
	);
};
